import { Dispatch } from 'redux';
import SuperpixelConfigurationController from '../controllers/SuperpixelController';
import commonHandler from '../errorHandlers/common-handler';
import {
  SuperpixelConfiguration,
  SuperpixelEventsResponse,
} from '../model/SuperpixelModel';
import { StoreState } from '../store-interfaces';
import { getActionHookBuilder } from './action-hook-builder';
import CrudActionContainer from './CrudActionContainer';

class SuperpixelConfigurationCRUDActions extends CrudActionContainer {
  eventsRetrieved: string;
  resetStore: string;

  constructor() {
    super('SUPERPIXEL_CONFIGURATION');
    this.eventsRetrieved = this.makeActionKey('EVENTS_RETRIEVED');
    this.resetStore = this.makeActionKey('RESET_STORE');
  }

  update(data: Partial<SuperpixelConfiguration> & { id: number }) {
    return async (dispatch: Dispatch<StoreState>) => {
      try {
        dispatch(this.busy(this.updateAction));
        const response = await SuperpixelConfigurationController.update(data);
        dispatch(this.retrieved(response));
        return response;
      } catch (e) {
        dispatch(this.unbusy());
        commonHandler(dispatch)(e);
      }
    };
  }

  fetch(facebookPageId: number) {
    return async (
      dispatch: Dispatch<StoreState>,
    ): Promise<SuperpixelConfiguration> => {
      try {
        const configuration = await SuperpixelConfigurationController.fetch(
          facebookPageId,
        );
        dispatch(this.retrieved(configuration));
        return configuration;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }

  getEvents(facebookPageId: number, force: boolean = false) {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.eventsRetrieved));
      try {
        const response: SuperpixelEventsResponse =
          await SuperpixelConfigurationController.getEvents(
            facebookPageId,
            force,
          );
        dispatch({
          type: this.eventsRetrieved,
          events: response.events,
        });
        return response;
      } catch (e) {
        commonHandler(dispatch)(e);
      }
    };
  }

  invalidateStore() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch({ type: this.resetStore });
    };
  }
}

const superpixelConfigurationCRUDActions =
  new SuperpixelConfigurationCRUDActions();

export default superpixelConfigurationCRUDActions;

export const useSuperpixelConfigurationCRUDActions = getActionHookBuilder(
  superpixelConfigurationCRUDActions,
  ['getEvents', 'update', 'fetch', 'invalidateStore'],
);
